
@switch (reason) {
  @case (verificationReasons.prescriberReferral) {
    <span>
      Reference to the prescriber
    </span>
  }
  @case (verificationReasons.prescriberOfficeReferral) {
    <span>
      Reference to the prescriber’s office
    </span>
  }
  @case (verificationReasons.specialityReferral) {
    <span>
      <span>
        Reference to the prescriber's specialty@if (specialityReferralSpeciality) {
        <span>:</span>
      }
      @if (specialityReferralSpeciality) {
        <div>{{ specialityReferralSpeciality }}</div>
      }
    </span>
  </span>
}
@case (verificationReasons.other) {
  <span>
    Other sufficient supporting documentation is present@if (otherNote) {
    <span>:</span>
  }
  @if (otherNote) {
    <div class="phi">{{ otherNote }}</div>
  }
</span>
}
@case (rejectionReasons.ignorePatient) {
  <span>
    Do not show me any further captures for patient
    <strong class="phi">{{ patient.fullName }} DOB {{ patient.dob | date: 'MM/dd/yyyy' }}</strong>.
  </span>
}
@case (rejectionReasons.ignorePrescriber) {
  <span>
    Do not show me any further captures from prescriber <strong>{{ provider.fullName }}</strong>.
  </span>
}
@case (rejectionReasons.ignorePatientPrescriber) {
  <span>
    Do not show me any further captures from prescriber <strong>{{ provider.fullName }}</strong> for patient
    <strong class="phi">{{ patient.fullName }} DOB {{ patient.dob | date: 'MM/dd/yyyy' }}</strong>.
  </span>
}
}
